import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MediaType } from '@app/store/shared/models';
import { TYPE_CHIP_CONFIGS } from '@shared/types/chip.type';
import { getTypeOptions } from '../type-options';

@Component({
    selector: 'app-media-add-modal',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.css'],
    imports: [TranslateModule],
})
export class AddComponent {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);

    readonly types = getTypeOptions().map((option) => ({
        ...option,
        icon: TYPE_CHIP_CONFIGS[option.value]?.icon ?? 'pi pi-question',
    }));

    selectType(type: MediaType): void {
        this.router.navigate(['../', type], { relativeTo: this.route });
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
